import React from 'react';

import { Anchor } from './Link.styles';

export type LinkProps = {
  linkText: string;
  href: string;
  target?: string;
  className?: string;
};

const Link = ({
  href,
  target,
  linkText,
  className,
}: LinkProps): React.ReactElement => (
  <Anchor
    href={href}
    target={target}
    rel={href.startsWith('http') ? 'noopener' : undefined}
    className={className}
  >
    {linkText}
  </Anchor>
);

export default Link;
